import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { buildPortalNav } from 'src/app/services/portal-access';
import { PortalRoleService } from 'src/app/services/portal-role.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss'],
})
export class PageLayoutComponent implements OnInit {
  public isExpanded = false;
  items: any[] = [];
  isLoading: boolean = false;
  profile: any;

  constructor(
    public authService: AuthService,
    private portalRoleService: PortalRoleService,
  ) {
    const data = localStorage.getItem('user_profile');
    if (data) {
      this.profile = JSON.parse(data);
    }
  }

  async ngOnInit(): Promise<void> {
    // Always refresh role from API so stale localStorage cannot hide Ops features.
    const me = await this.portalRoleService.loadMe();
    this.items = buildPortalNav(me?.role, environment.production);
  }

  public toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  public async logout() {
    this.isLoading = false;
    await this.authService.logout();
    this.isLoading = false;
  }
}
